import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { SnackbarContext } from "../../../../contexts/Snackbar";
import { returnSubmit } from "../../../../enums/queryFunction/Submit";

export default function usePermissionPut(url, key) {
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(false);
  const queryClient = useQueryClient();

  const queryKey = key;

  const submitCallback = async (obj) => {
    setLoading(true);
    mutate(obj);
  };

  function updateKey(key, newData) {
    queryClient.invalidateQueries([key]);
  }

  const { mutate } = useMutation({
    mutationFn: async (data) => {
      await returnSubmit(url, data);
      return data;
    },
    onSuccess: (data) => {
      if (Array.isArray(queryKey)) {
        queryKey.forEach((key) => updateKey(key, data));
      } else {
        updateKey(queryKey, data);
      }
      handleSnackbar("successMessage", "success");
      setLoading(false);
    },
    onError: (error) => {
      handleSnackbar("errorMessage", "error");
      setLoading(false);
    },
  });

  return {
    submitCallback,
    loading,
  };
}
